<template>
  <v-card 
    class="pa-3" 
    width="auto"
    style="border-radius: 32px;"
    >
    <v-card-title class="text-h5">INP-Platzbuchung</v-card-title>
    <v-card-title class="text-h6 mt-n4">Benutzer: {{ passwordCardUser }}</v-card-title>
    <v-card-title class="text-subtitle-1">Passwort ändern:</v-card-title>
    <v-card-subtitle class="mt-n2">Das Passwort muss mindestens sechs Zeichen lang sein, <br> 
                                    sowie eine Zahl und einen Großbuchstaben enthalten!</v-card-subtitle>
    <v-card-text>
      <v-form class="justify-center">

        <v-alert
          v-if="errorMessage"
          type="error"
          class="mt-2 mb-4"
          dense
          outlined
        >
          {{ errorMessage }}
        </v-alert>

        <v-text-field
          v-model="oldPassword"
          label="Altes Passwort"
          prepend-inner-icon="mdi-key"
          :type="showPasswordOld ? 'text' : 'password'"
          :append-inner-icon="showPasswordOld ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append-inner="togglePasswordOldVisibility"
          required
        ></v-text-field>

        <v-text-field
          v-model="newPassword"
          label="Neues Passwort"
          prepend-inner-icon="mdi-key-outline"
          :type="showPasswordNew ? 'text' : 'password'"
          :append-inner-icon="showPasswordNew ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append-inner="togglePasswordNewVisibility"
          required
        ></v-text-field>

        <v-text-field
          v-model="newPasswordConfirm"
          label="Neues Passwort bestätigen"
          prepend-inner-icon="mdi-key-outline"
          :type="showPasswordConfirm ? 'text' : 'password'"
          :append-inner-icon="showPasswordConfirm ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append-inner="togglePasswordConfirmVisibility"
          required
        ></v-text-field>

        <v-row class="justify-center">
          <v-col cols="auto" class="mt-n4">
            <v-btn 
              color="red" 
              class="mt-4"
              prepend-icon="mdi-pencil" 
              @click="showDialogPassword">
                  Passwort ändern
            </v-btn>
          </v-col>
          <v-col cols="auto" class="mt-n4">
            <v-btn 
              type="submit" 
              color="grey" 
              class="mt-4" 
              block 
              :to="'/Dashboard'" 
              link
              >
                  Abbrechen
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>

  <PasswordDialog
    ref="passwordDialogRef"
    :pwDialogOld="oldPassword"
    :pwDialogNew="newPassword" 
  />

</template>

<script>

import PasswordDialog from './PasswordChangeDialog.vue';

  export default {
    components: {
      PasswordDialog
    },
    data() {
      return {
        oldPassword: '',
        newPassword: '',
        newPasswordConfirm: '',
        showPasswordOld: false,
        showPasswordNew: false,
        showPasswordConfirm: false,
        errorMessage: '',
      }
    },
    props: {
      passwordCardUser:{
        type: String,
        required: true
      }
    },
    methods: {
      isPasswordValid(password) {
        const minLength = password.length >= 6;
        const hasNumber = /\d/.test(password);
        const hasCaps = /[A-Z]/.test(password);
        return minLength && hasNumber && hasCaps;
      },
      checkPassword(){
        this.errorMessage = '';

        if(this.newPassword !== this.newPasswordConfirm) {
          this.errorMessage = 'Die Passwörter stimmen nicht überein!';
          this.clearError();
          return false;
        }

        if(!this.isPasswordValid(this.newPassword)) {
          this.errorMessage =
            'Das neue Passwort entspricht nicht den Voraussetzugen, ' + 
              'bitte vesuchen Sie es unter den angegebenen Vorschriften erneut!'
          this.clearError();
          return false;
        }
        return true;
      },
      showDialogPassword(){
        if(!this.checkPassword()) return;
        this.$refs.passwordDialogRef.openDialogPassword();
      },
      clearError() {
        setTimeout(() => {
          this.errorMessage = '';
        }, 3500); 
      },
      togglePasswordOldVisibility() {
        this.showPasswordOld = !this.showPasswordOld;
      },
      togglePasswordNewVisibility() {
        this.showPasswordNew = !this.showPasswordNew;
      },
      togglePasswordConfirmVisibility() {
        this.showPasswordConfirm = !this.showPasswordConfirm;
      }
    }
  }
</script>